import { kExtraSmallButtonStandardSize } from "../constants";
import { QZoomButton } from "../CoreApp/QZoomButton";

export function PAddZoomControl(x, y, plus, hoverCode, cmdCode, panel, smallButton) {
  var z = new QZoomButton();
  z.InitZoomButton(plus);
  z.PositionElement(x, y);

  var sx = kExtraSmallButtonStandardSize;
  var sy = kExtraSmallButtonStandardSize;
  if (smallButton) {
    sx = 17;
    sy = 16;
    z.SetSizing(true);
  }
  z.SizeElement(sx, sy);
  z.SetHoverCode(hoverCode);
  z.SetCmdCode(cmdCode);
  panel.PushElement(z);
  return z;
}
